import { render, staticRenderFns } from "./comp-icon.vue?vue&type=template&id=3a0cfb6d&scoped=true"
import script from "./comp-icon.vue?vue&type=script&lang=js"
export * from "./comp-icon.vue?vue&type=script&lang=js"
import style0 from "./comp-icon.vue?vue&type=style&index=0&id=3a0cfb6d&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0cfb6d",
  null
  
)

export default component.exports